import makeRequest from './client';

const baseURL = `/api/datadog`;

export const getUsageReportData = (filters?: {
  organization?: string;
  from?: string;
  to?: string;
}) => {
  const queryParams = new URLSearchParams();
  if (filters?.organization) queryParams.append('organization', filters.organization);
  if (filters?.from) queryParams.append('from', filters.from);
  if (filters?.to) queryParams.append('to', filters.to);
  
  const finalURL = `${baseURL}/rum?${queryParams.toString()}`;
  return makeRequest(finalURL, 'GET');
};